import { createTheme } from "@mui/material/styles";

export default createTheme({
  // The app's own floating admin panels (listsManager.js, qilManager.js,
  // dynamicItemManager.js, gmaps.js, floatingWindow.js, qrDialog.js,
  // EnterNumber.js, DisplayText.js, teamMatesSelect.js) sit at zIndex:1400,
  // above MUI's default modal zIndex of 1300 - so any Select/Autocomplete
  // menu opened from inside one of them rendered behind the panel: visually
  // invisible, but still the real, interactive element (a click there still
  // registered). Raised above 1400 so those menus render on top instead.
  zIndex: {
    modal: 1450,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
        fullWidth: true,
      },
    },
    // @mui/x-date-pickers' DatePicker/TimePicker render through their own
    // PickersTextField, not MuiTextField - the override above never
    // reaches it, so without this it defaults to PickersTextField's own
    // "outlined" variant, a bordered box inconsistent with every other
    // "standard" underline field in the app.
    MuiPickersTextField: {
      defaultProps: {
        variant: "standard",
        fullWidth: true,
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          minWidth: "150px",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "&:has(.MuiSelect-select)": {
            minWidth: "150px",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          display: "flex",
          marginBottom: "8px",
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: "4px 16px",
        },
        avatar: {
          marginRight: "8px",
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
          },
        },
        title: {
          fontSize: "1rem",
          fontWeight: 600,
          lineHeight: 1.3,
        },
        subheader: {
          fontSize: "0.75rem",
          lineHeight: 1.3,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "2px 16px",
          "&:last-child": {
            paddingBottom: "6px",
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: "0 8px",
          minHeight: 0,
        },
      },
    },
  },
});
